import { MantineThemeOverride } from '@mantine/core';

export type CloseButtonTheme = NonNullable<MantineThemeOverride['components']>['CloseButton'];

export const CloseButton: CloseButtonTheme = {
  // todo: define
};
